<template>
    <b-sidebar
        id="event-form-sidebar"
        :visible="isEventFormSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @shown="getData(eventData, eventType)"
        @hidden="resetForm"
        @change="(val) => $emit('update:is-event-form-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <div
                class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
            >
                <h5 class="mb-0">Event Form</h5>
                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="close(hide)"
                />
            </div>
            <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
                <b-form
                    class="p-2"
                    @submit.prevent="handleSubmit(onSubmit)"
                    @reset.prevent="resetForm"
                >
                    <b-tabs v-model="tabIndex">
                        <b-tab title="Content">
                            <b-tabs content-class="mt-1" v-if="langs.length > 0">
                                <b-tab
                                    v-for="(lang, key) in langs"
                                    :key="'tab-' + key"
                                    :title="lang.name"
                                >
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'title_name_' + lang.code"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label="Title"
                                            :label-for="'title_' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'title_' + lang.code"
                                                v-model="Data.title[lang.code]"
                                                autofocus
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'title (' + lang.code + ')'"
                                                @input="changeTitle(lang.code)"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'sub_title_name_' + lang.code"
                                    >
                                        <b-form-group
                                            label="Sub Title"
                                            :label-for="'sub_title_name_' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'sub_title_name_' + lang.code"
                                                v-model="Data.sub_title[lang.code]"
                                                autofocus
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'sub title (' + lang.code + ')'"
                                                @input="changeTitle(lang.code)"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'description_' + lang.code"
                                        rules="min:0"
                                    >
                                        <b-form-group
                                            label="Description"
                                            :label-for="'description_' + lang.code"
                                        >
                                            <quill-editor
                                                :options="editorOptions"
                                                :id="'description_' + lang.code"
                                                v-model="Data.description[lang.code]"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'slug' + lang.code"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label="Slug"
                                            :label-for="'slug' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'slug' + lang.code"
                                                v-model="Data.slug[lang.code]"
                                                autofocus
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'Slug (' + lang.code + ')'"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'button_name_booking' + lang.code"
                                    >
                                        <b-form-group
                                            label="Button Name - Booking"
                                            :label-for="'button_name_booking' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'button_name_booking' + lang.code"
                                                v-model="Data.button_name_booking[lang.code]"
                                                autofocus
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'Button Name Booking (' + lang.code + ')'"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'url_' + lang.code"
                                    >
                                        <b-form-group
                                            label="Booking URL"
                                            :label-for="'url_' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'url_' + lang.code"
                                                v-model="Data.url_book_now[lang.code]"
                                                autofocus
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'url (' + lang.code + ')'"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'button_name_' + lang.code"
                                    >
                                        <b-form-group
                                            label="Button Name - Explore More"
                                            :label-for="'button_name_' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'button_name_' + lang.code"
                                                v-model="Data.button_name[lang.code]"
                                                autofocus
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'Button Name Explore More (' + lang.code + ')'"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <div v-for="(icon, index) in Data.icons" :key="index">
                                        <b-row align-v="center">
                                            <b-col cols="1" align-self="center">
                                                <b-img
                                                    :src="`${icon.icon? icon.icon.path: icon.path}`"
                                                    height="75"
                                                    width="75"
                                                    class="rounded mr-2 mb-1 mb-md-0"
                                                />
                                            </b-col>
                                            <b-col cols="1">
                                                {{ icon.name[lang.code] }}
                                            </b-col>
                                            <b-col>
                                                <validation-provider
                                                    #default="validationContext"
                                                    :name="'value_' + lang.code"
                                                >
                                                    <b-form-group
                                                        label="Value"
                                                        :label-for="'value__' + lang.code"
                                                    >
                                                        <b-form-input
                                                            :id="'value_' + lang.code"
                                                            v-model="icon.value[lang.code].value"
                                                            autofocus
                                                            :state="getValidationState(validationContext)"
                                                            trim
                                                            :placeholder="'value (' + lang.code + ')'"
                                                        />
                                                        <b-form-invalid-feedback>
                                                            {{ validationContext.errors[0] }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-tab>
                            </b-tabs>
                            <hr/>
                            <validation-provider
                                #default="validationContext"
                                :name="'explore_url'"
                            >
                                <b-form-group
                                    label="Explore More URL"
                                    :label-for="'explore_url'"
                                >
                                    <b-form-input
                                        :id="'explore_url'"
                                        v-model="Data.explore_url"
                                        autofocus
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="`url`"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                v-if="eventType === 'meetings&events'"
                                #default="validationContext"
                                name="IsShow"
                                rules="min:0"
                            >
                                <b-form-group label="Show on zip site" label-for="IsShow">
                                    <b-form-checkbox
                                        id="isshow"
                                        checked="false"
                                        class="custom-control-success"
                                        v-model="Data.is_show"
                                        switch
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <div>
                                <b-button
                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    variant="outline-primary"
                                    class="mr-2"
                                    @click="uploadImage('image')"
                                >
                                    Upload Image
                                </b-button>
                                <file-lists
                                    :is-modal-file-lists-show.sync="isModalFileListsShow"
                                    :uploadType="uploadType"
                                    @refesh="refesh"
                                />
                            </div>
                            <br/>
                            <div>
                                <validation-provider
                                    #default="validationContext"
                                    name="cover_image_id"
                                    rules="required"
                                >
                                    <b-form-group label="Cover Image" label-for="image">
                                        <div id="cover_image_id">
                                            <treeselect 
                                                @input="eventSelected"
                                                v-model="model" 
                                                placeholder="Choose Folder"
                                                :reduce="(option) => option.id"
                                                label="title"
                                                :options="folderOptions"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                noChildrenText
                                            />
                                        </div>
                                        <b-form-invalid-feedback>
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>
                                <div>
                                    <b-container align-h="center">
                                        <b-row>
                                            <b-col 
                                                cols="3"
                                                v-for="(image, index) in images"
                                                :key="index"
                                                class="pt-2"
                                            >
                                            <img 
                                                @click="eventSelectedCoverImg(image)"
                                                :src="image.path"
                                                width="300"
                                                height="200"
                                                :class="selectedCoverImage==null
                                                    ? '' 
                                                    : selectedCoverImage.id == image.id
                                                        ? 'selected-img'
                                                        : 'disable-img'
                                                "
                                            >
                                            <br/>
                                        </b-col>
                                        <hr/>
                                        </b-row>
                                    </b-container>
                                    <br/>
                                </div>
                                <div v-if="selectedCoverImage!==null">
                                    <hr/>
                                    <div>Choose Guide Images</div>
                                    <b-container align-h="center">
                                        <b-row>
                                            <b-col 
                                                cols="3"
                                                v-for="(image, index) in images.filter(image => image.id !== selectedCoverImage.id)"
                                                :key="index"
                                                class="pt-2"
                                            >
                                            <img 
                                                @click="eventImgSelected(image)"
                                                :src="image.path"
                                                width="300"
                                                height="200"
                                                :class="selectedImages.some(v => v.id === image.id)? 'selected-img' : ''"
                                            >
                                        </b-col>
                                        <hr/>
                                        </b-row>
                                    </b-container>
                                    <br/>
                                </div>
                            </div>
                            <validation-provider
                                #default="validationContext"
                                name="IsActive"
                                rules="min:0"
                            >
                                <b-form-group label="Is Active" label-for="IsActive">
                                    <b-form-checkbox
                                        id="isactive"
                                        checked="true"
                                        class="custom-control-success"
                                        v-model="Data.is_active"
                                        switch
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <repeater-section-form
                                v-if="isEventFormSidebarActive && eventData"
                                @refesh-list="refeshList"
                                :event-data="eventData"
                                :event-input-content-remove.sync="EventInputContentRemove"
                                :event-input-content.sync="EventInputContent"
                            />
                        </b-tab>
                        <b-tab title="Gallery" v-if="eventData">
                            <upload-form v-if="tabIndex == 1" :event-data.sync="eventData" />
                        </b-tab>
                        <b-tab title="SEO">
                            <validation-provider
                              #default="validationContext"
                              name="meta_title"
                              rules="min:0"
                            >
                              <b-form-group label="Meta Title" label-for="meta_title">
                                <b-form-input
                                  id="meta_title"
                                  v-model="Data.meta_title"
                                  autofocus
                                  :state="getValidationState(validationContext)"
                                  trim
                                  placeholder="Meta Title"
                                />
                                <b-form-invalid-feedback>
                                  {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                            <validation-provider
                              #default="validationContext"
                              name="meta_description"
                              rules="min:0"
                              
                            >
                              <b-form-group
                                label="Meta Description"
                                label-for="meta_description"
                              >
                                <b-form-input
                                  id="meta_description"
                                  v-model="Data.meta_description"
                                  autofocus
                                  :state="getValidationState(validationContext)"
                                  trim
                                  placeholder="Meta Description"
                                />
              
                                <b-form-invalid-feedback>
                                  {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                name="meta_keywords"
                                rules="min:0"
                            >
                                <b-form-group
                                    label="Meta Keywords"
                                    label-for="meta_keywords"
                                >
                                    <b-form-input
                                        id="meta_keywords"
                                        v-model="Data.meta_keyword"
                                        autofocus
                                        :state="getValidationState(validationContext)"
                                        trim
                                        placeholder="Meta Keywords"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                          </b-tab>
                    </b-tabs>
                    <div class="d-flex mt-2">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="outline-success"
                          class="mr-2"
                          type="submit"
                        >
                          Save
                        </b-button>
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          type="button"
                          variant="outline-danger"
                          @click="close(hide)"
                        >
                          Cancel
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </template>
    </b-sidebar>
</template>
    
<script>
    import { $themeConfig } from '@themeConfig'
    import {
        BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
        BButton, BTabs, BTab, BCard, BCardText, BFormRadio, BFormRadioGroup, BFormCheckboxGroup, BContainer,
        BRow, BCol, BMedia, BMediaAside, BMediaBody, BAvatar, BImg, BLink, BFormFile,
    } from "bootstrap-vue";
    import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
    import { required, alphaNum, email, password,confirmed } from '@validations'
    import { ValidationProvider, ValidationObserver } from "vee-validate";
    import vSelect from "vue-select";
    import store from "@/store";
    import languagesStoreModule from "@/views/languages/languagesStoreModule";
    import formValidation from "@core/comp-functions/forms/form-validation";
    import Ripple from "vue-ripple-directive";
    import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
    import { useToast } from "vue-toastification/composition";
    import { ref, onUnmounted } from "@vue/composition-api";
    import { slugify } from '@/@fake-db/utils'
    import { quillEditor } from "vue-quill-editor";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.bubble.css";
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import UploadForm from "../event-form/UploadForm.vue"
    import RepeaterSectionForm from "../event-form/RepeaterSectionForm.vue"
    import eventSectionStoreModule from '../../eventSectionStoreModule';
    import eventBlockStoreModule from '../../eventBlockStoreModule';
    import FileLists from '../../../uploadStorage/FileLists.vue'
    import folderStoreModule from '../../../files/folderStoreModule'
    
    export default {
        components: {
            BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
            BButton, BTabs, BTab, BCard, BCardText, vSelect, ValidationProvider, ValidationObserver, 
            BFormRadio, quillEditor, Treeselect, BFormRadioGroup, BFormCheckboxGroup, BContainer, BRow, 
            BCol, BMedia, BMediaAside, BMediaBody, BAvatar, BImg, BLink, BFormFile, UploadForm,
            RepeaterSectionForm, FileLists,
        },
        directives: {
            Ripple,
        },
        model: {
            prop: "isEventFormSidebarActive",
            event: "update:is-event-form-sidebar-active",
        },
        props: {
            isEventFormSidebarActive: {
                type: Boolean,
                required: true,
            },
            eventData: {
                type: Object,
                required: false,
            },
            eventType: {
                type: String,
                required: true
            }
        },
        computed: {
            currentLocale(){
                return this.$i18n.locale;
            },
            folderOptions(){
                return this.folders.map((folder) => this.formatFolder(folder))
            },
            editorOptions (){
                return $themeConfig.snowOption
            } 
        },
        methods: {
            formatFolder(folder){
                return{
                    id: folder.id,
                    label: folder.title,
                    children: folder.subFolders.length? folder.subFolders.map(this.formatFolder): undefined
                }
            },
            // loadOptions({ action, parentNode, callback }) {
            //     // Simulating an API call to fetch children
            //     setTimeout(() => {
            //         callback(null, []);
            //     }, 1000);
            // }
        },
        setup(props, { emit }){
            const {  appRef } = $themeConfig.app
            const toast = useToast();
            const userStorage = JSON.parse(localStorage.getItem('userData'));
            const getLocalSite = JSON.parse(localStorage.getItem('site'))
            const EventInputContentRemove = ref([])
            const EventInputContent = ref([])
            const uploadType = ref('')

            const LANGUAGES_STORE_MODULE_NAME = "app-languages";
            if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME))
            store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule);
            onUnmounted(() => {
                if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME);
            });

            const CONTENT_STORE_MODULE_NAME = 'event-section';
            if (!store.hasModule(CONTENT_STORE_MODULE_NAME)) store.registerModule(CONTENT_STORE_MODULE_NAME, eventSectionStoreModule)
            onUnmounted(() => {
                if (store.hasModule(CONTENT_STORE_MODULE_NAME)) store.unregisterModule(CONTENT_STORE_MODULE_NAME)
            });

            const BLOCK_STORE_MODULE_NAME = 'section-block';
            if (!store.hasModule(BLOCK_STORE_MODULE_NAME)) store.registerModule(BLOCK_STORE_MODULE_NAME, eventBlockStoreModule)
            onUnmounted(() => {
                if (store.hasModule(BLOCK_STORE_MODULE_NAME)) store.unregisterModule(BLOCK_STORE_MODULE_NAME)
            });

            const FOLDER_STORE_MODULE_NAME = 'files-folder'
            if (!store.hasModule(FOLDER_STORE_MODULE_NAME)) store.registerModule(FOLDER_STORE_MODULE_NAME, folderStoreModule)
            onUnmounted(() => {
                if (store.hasModule(FOLDER_STORE_MODULE_NAME)) store.unregisterModule(FOLDER_STORE_MODULE_NAME)
            });

            const eventType = ref('')

            const blankData = {
                meta_title: '',
                meta_description: '',
                meta_keyword: '',
                slug: {},
                cover_image: '',
                is_active: true,
                ordering_count: 0,
                title: {},
                sub_title: {},
                description: {},
                url_book_now: {},
                button_name:{},
                button_name_booking:{},
                values: {},
                cover_image: [],
                files: [],
                icons: [],
                explore_url: '',
                event_type: eventType,
                sites_id: getLocalSite.id,    
                created_by: userStorage.id,
                is_show: false,
            };
    
            const Data = ref(blankData);
            const oldValue  =  ref(null)
            const tabIndex = ref(0);
            const langs = ref([]);
            const iconsData = ref([])
            const isModalFileListsShow = ref(false)
            const images = ref([])
            const folders = ref([])
            const parent = ref(0);
            const selectedCoverImage = ref("")
            const selectedRoomImages = ref([])
            const model = ref(null)
            const selectedImages = ref([])
            const dataData = ref(blankData)
    
            const resetData = () => {
                Data.value = blankData;
            };
    
            const changeTitle  = (lang) => {
                if(lang){
                    Data.value.slug[lang] = slugify(Data.value.title[lang]);
                }
            }

            const close = (hidden) => {
                for(const lang in oldValue.value?.title ?? {}) {
                    Data.value.title[lang] = oldValue.value.title[lang]
                }

                for(const lang in oldValue.value?.slug ?? {}) {
                    Data.value.slug[lang] = oldValue.value.slug[lang]
                }

                hidden()
            }

            const refesh = () => {
                store.dispatch('files-folder/getFolders', {
                    parent: parent.value,
                    order_by:'ordering_count ASC'
                })
                .then(response => {
                    const res = response.data.data
                    folders.value = res
                })

                model.value = null
                images.value = []
                selectedCoverImage.value = null
                selectedImages.value = []
                eventType.value = type
            }
    
            const getData = async function (data, type) {
                tabIndex.value = 0;

                store.dispatch('files-folder/getFolders', {
                    parent: parent.value,
                    order_by:'ordering_count ASC'
                })
                .then(response => {
                    const res = response.data.data
                    folders.value = res
                })

                Data.value.meta_title = ''
                Data.value.meta_description = ''
                Data.value.meta_keyword = ''
                Data.value.slug = {}
                Data.value.cover_image = ''
                Data.value.title = {}
                Data.value.sub_title = {}
                Data.value.description = {}
                Data.value.url_book_now = {}
                Data.value.button_name = {}
                Data.value.button_name_booking = {}
                Data.value.is_active = true
                Data.value.explore_url = ''
                Data.value.is_show = false

                model.value = null
                images.value = []
                selectedCoverImage.value = null
                selectedImages.value = []
                eventType.value = type

                if(data) {
                    data.is_active = data.is_active? true: false
                    data.is_show = data.is_show? true: false
                    Data.value = data

                    oldValue.value = JSON.parse(JSON.stringify({...data}))

                    model.value = null
                    images.value = []
                    selectedCoverImage.value = null
                    selectedImages.value = []
                    EventInputContent.value = []
                    
                    if(data.content.length){
                        EventInputContent.value = data.content
                    }

                    if(data.files.length){
                        const files = data.files
                        const folderId = files[0].folder_id
                        
                        store.dispatch('files-folder/getFolderById', folderId)
                            .then(response => {
                                const res = response.data.data
                                images.value = res[0].images

                                model.value = folderId
                                for(const file of files){
                                    if(file.is_feature){
                                        selectedCoverImage.value = file
                                    } else {
                                        selectedImages.value.push(file)
                                    }
                                }
                        })
                    }

                }
            }
    
            const getLangs = (filter) => {
                store.dispatch("app-languages/fetchData", filter).then((res) => {
                    if (res.data.success) {
                        langs.value = res.data.data;
                    }
                });
            };
    
            let filter = {
                is_active:1,
            }
    
            const onSubmit = async () => {
                Data.value.is_active = Data.value.is_active?1:0;
                Data.value.is_show = Data.value.is_show?1:0;

                if(!Data.value.id){
                    Data.value.cover_image = selectedCoverImage.value
                    Data.value.files = selectedImages.value

                    store.dispatch('app-event/addEvent', {
                        data: Data.value
                    }).then((res) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Success`,
                                icon: 'BellIcon',
                                variant: 'success',
                                text: `${res.data.message}`,
                            },
                        });

                        emit('refetch-data')
                        emit('update:is-event-form-sidebar-active', false)
                    }).catch((error) => {
                        toast({
                            component: ToastificationContent,
                            position: "top-right",
                            props: {
                                title: `Error`,
                                icon: "BellIcon",
                                variant: "danger",
                                text: error.response.data.message,
                            },
                        });
                    })
                } else {
                    Data.value.cover_image = selectedCoverImage.value

                    if(!Data.value.cover_image){
                        Data.value.files = []
                    } else {
                        Data.value.files = selectedImages.value
                    }

                    store.dispatch('app-event/updateEvent', {
                        data: Data.value
                    }).then((res) => {
                            toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                title: `Success`,
                                icon: 'BellIcon',
                                variant: 'success',
                                text: `${res.data.message}`,
                                },
                            });
                            emit('refetch-data')
                            emit('update:is-event-form-sidebar-active', false)
                    }).catch((error) => {
                        toast({
                            component: ToastificationContent,
                            position: "top-right",
                            props: {
                                title: `Error`,
                                icon: "BellIcon",
                                variant: "danger",
                                text: error.response.data.message,
                            },
                        });
                    })
                }
            }
    
            const refeshList = async () => {
                emit("refetch-data");
            };
    
            getLangs(filter);

            const refInputEl = ref(null);
            const refPreviewEl = ref(null);

            const { inputImageRenderer } = useInputImageRenderer(
                refInputEl,
                (base64) => {
                    refPreviewEl.value.src = base64;
                }
            );

            const revomeImage = () => {
                Data.value.featuredImage = require("@/assets/images/no-image.png");
                // Data.value.cover_image = "";
            };

            const uploadImage = (type) => {
                uploadType.value = type
                isModalFileListsShow.value = true
            }

            const eventSelected = (id) => {
                if(id){
                    store.dispatch('files-folder/getFolderById', id)
                    .then(response => {
                        const res = response.data.data
                        images.value = res[0].images

                        const existingFolderId = Data?.value?.files[0]?.folder_id

                        if(model.value != existingFolderId){
                            selectedCoverImage.value = null
                            selectedImages.value = []
                        }
                    })
                }
            }

            const eventSelectedCoverImg = (data) => {
                const coverImg = selectedCoverImage.value

                if(coverImg == null){
                    selectedCoverImage.value = data
                    return
                }

                if(coverImg?.id == data.id){
                    selectedCoverImage.value = null
                    return
                }
            }

            const eventImgSelected = (data) => {
                const index = selectedImages.value.findIndex(item => item.id === data.id);
                index === -1 ? selectedImages.value.push(data) : selectedImages.value.splice(index, 1);
            }

            const {
                resetForm,
                getValidationState,
                refFormObserver
            } = formValidation(resetData);
    
            return {
                langs,
                getData,
                resetData,
                resetForm,
                getValidationState,
                refFormObserver,
                tabIndex,
                Data,
                onSubmit,
                changeTitle,
                refeshList,
                refPreviewEl,
                inputImageRenderer,
                revomeImage,
                refInputEl,
                iconsData,
                EventInputContentRemove,
                EventInputContent,
                close,
                oldValue,
                uploadImage,
                isModalFileListsShow,
                images,
                folders,
                parent,
                selectedCoverImage,
                selectedRoomImages,
                eventSelected,
                model,
                eventSelectedCoverImg,
                eventImgSelected,
                selectedImages,
                dataData,
                refesh,
                uploadType,
            }
        }
    }
    </script>
    
    <style lang="scss">
        @import "@core/scss/vue/libs/quill.scss";

        .selected-img{
            border: solid 5px #FFB341;
        }
    
        .disable-img{
            cursor: not-allowed;
            opacity: 0.5;
        }
    </style>